/** Sample Allocation › All samples (QC meeting, 2026-10-16): allocate across received SRFs. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { AllocationSamplesPage } from "@/features/quality/components/allocation/allocation-samples-page";

const id = z.number().int().positive().optional().catch(undefined);
const text = z.string().optional().catch(undefined);

const search = z.object({
  srfNo: text,
  crop: text,
  varietyId: id,
  stageId: id,
  lot: text,
  assigned: z
    .enum(["unassigned", "all"])
    .default("unassigned")
    .catch("unassigned"),
  page: z.number().int().min(1).default(1).catch(1),
});

export const Route = createFileRoute("/_app/quality/allocation/samples")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.allocate")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <AllocationSamplesPage
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
